import {GET_NOTIFICATION } from "../../../components/common/api";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  fetchNotificationStart,
  fetchNotificationSuccess,
  fetchNotificationFailure,
} from "../../reducer/NotificationReducer/NotificationReducer";

// ............. Get Notification Details.................

let isGetNotification = false;
export const GetNotification =
  (currentPage, itemsPerPage) => async (dispatch) => {
    if (isGetNotification) return;
    isGetNotification = true;
    dispatch(fetchNotificationStart());
    try {
       const params = {
         page: currentPage,
         size: itemsPerPage,
        //  sort: sortField || "createdAt",
        //  order: sortOrder || "DESC",
       };
      const response = await axiosInstance.get(`${GET_NOTIFICATION}`, {
        params,
      });

      if (response.status !== 200) {
        throw new Error("Failed to fetch inspector details.");
      }
      dispatch(fetchNotificationSuccess(response?.data));
    } catch (error) {
      console.error("Error fetching details:", error);
      dispatch(fetchNotificationFailure(error.message));
    } finally {
      isGetNotification = false;
    }
  };
